/**
 * 覆盖翻译平台自动同步的数据，一般用于紧急文案缺失的问题，避免delay
 * 正常情况一定要按标准流程，让产品翻译平台提翻译需求
 */
export default {
   'zh-CN': {
    Gattaran_Feedback_PXop_Eszz: '运营协助',
    Gattaran_Feedback_tIFD_xuzA: '产品建议',
    Gattaran_Feedback_aLLw_KcWa: '技术咨询',
  },
  'en-US': {
    Gattaran_Feedback_PXop_Eszz: 'Operation request',
    Gattaran_Feedback_tIFD_xuzA: 'Product suggest',
    Gattaran_Feedback_aLLw_KcWa: 'Technical consult',
  },
  'es-MX': {
    Gattaran_Feedback_PXop_Eszz: 'Asistencia operativa',
    Gattaran_Feedback_tIFD_xuzA: 'Sugerencias al producto',
    Gattaran_Feedback_aLLw_KcWa: 'Consulta técnica',
  },
  'ja-JP': {
    // 'FoodD_payout_Company_Registration_zoVW': 'Número de registro'
  },
  'pt-BR': {
    Gattaran_Feedback_PXop_Eszz: 'Questões de operação',
    Gattaran_Feedback_tIFD_xuzA: 'Sugestões de produto',
    Gattaran_Feedback_aLLw_KcWa: 'Consulta técnica',
  },
};
